import cn from 'classnames';
// Types
import { GetAllAmas_amas_entities } from 'api/ama/types/GetAllAmas';
import { GetAllHomePageData_getHomePageData_amas } from 'api/homePage/types/GetAllHomePageData';
import {
  GetStoreBySlug_store,
  GetStoreBySlug_store_amas,
} from 'api/store/types/GetStoreBySlug';
import { GetStoreAmas_store } from 'api/ama/types/GetStoreAmas';
// Constants
import { ORDER_AMA } from 'constants/routes';
// Helpers
import { formatCurrencyString } from 'helpers/formatCurrencyString';
import { getStreamerName } from 'helpers/streams';
// Ui

import styles from './AmaListItem.module.scss';
import VideoCard from 'ui3/Card/VideoCard';
import { ProductTypesType } from 'api/graphql-global-types';

type StoreAma = GetStoreBySlug_store_amas & {
  store: GetStoreBySlug_store | GetStoreAmas_store;
};

type AmaListItemProps = {
  ama:
    | GetAllAmas_amas_entities
    | GetAllHomePageData_getHomePageData_amas
    | StoreAma;
  type?: 'list' | 'carousel' | 'store';
  priorityImageLoading?: boolean;
  playInModal?: boolean;
};

const AmaListItem = ({
  ama,
  type = 'list',
  priorityImageLoading,
  playInModal = false,
}: AmaListItemProps) => {
  const storeSlug = ama?.store?.slug || '';
  const storeName = getStreamerName(ama?.store);
  const amaVideoURL = ama?.videoURL || '';
  const amaPrice = Number(ama?.price || 0);
  const videoThumbnailURL = ama?.videoThumbnailURL;
  const isStoreType = type === 'store';
  const isCarouselType = type === 'carousel';
  const isListType = type === 'list';
  const withImagePreload = priorityImageLoading || isStoreType;
  const sport =
    (ama.store && 'sports' in ama.store && ama.store.sports?.[0]?.name) || '';

  return (
    <VideoCard
      className={cn(styles.root, {
        [styles.carouselItem]: isCarouselType,
        [styles.storeType]: isStoreType,
        [styles.listType]: isListType,
      })}
      descriptionClassName={styles.infoWrapper}
      type={sport ? sport : ProductTypesType.Ama}
      title={storeName}
      userUrl={`/${storeSlug}`}
      linkUrl={isStoreType ? '' : `${ORDER_AMA}/${storeSlug}`}
      imageUrl={videoThumbnailURL ?? ''}
      price={formatCurrencyString(amaPrice)}
      priorityImageLoading={withImagePreload}
      videoURL={amaVideoURL}
      videoId={ama.id}
      amaAttributes={{
        amaType: ama.type,
        amaSlug: storeSlug,
      }}
      imageWrapperClassname={cn(styles.amaVideo, {
        [styles.carouselItem]: isCarouselType,
        [styles.storeType]: isStoreType,
        [styles.listType]: isListType,
      })}
      showTitle={type !== 'store'}
      playInModal={playInModal}
    />
  );
};

export default AmaListItem;
